import Pica from 'pica'
const pica = Pica()

export const MODES = Object.freeze(['fit', 'contain'])

const defaults = {
  maxPixel: 5e6,
  width: null,
  height: null,
  mode: MODES[0],
  bgColor: 'rgb(255, 255, 255)'
}

// NOTE: 「Canvas area exceeds the maximum limit (width * height > 16777216).」対策
const MAX_IOS_PIXELS = 16777216

export default class ImageResizer {
  constructor(image, orientation, settings = {}) {
    this.image = image
    this.orientation = orientation
    this.settings = Object.assign(defaults, settings)

    this.initCanvas()
  }

  initCanvas() {
    this.setCanvasSizePerMode()

    let canvasPixels = this.canvasWidth * this.canvasHeight
    if (canvasPixels > MAX_IOS_PIXELS) {
      let imagePixels = this.image.width * this.image.height
      let ratio = canvasPixels / imagePixels
      this.canvasWidth = Math.ceil(this.canvasWidth * ratio)
      this.canvasHeight = Math.ceil(this.canvasHeight * ratio)
    }

    this.canvas = document.createElement('canvas')
    this.canvas.width = this.canvasWidth
    this.canvas.height = this.canvasHeight
    this.canvasContext = this.canvas.getContext('2d')
  }

  setCanvasSizePerMode() {
    this.canvasWidth = this.image.width
    this.canvasHeight = this.image.height

    if (this.settings.mode === 'fit') {
      this.setReizeSize()
    } else if (this.settings.mode === 'contain') {
      this.setContainSize()
    }
  }

  setReizeSize() {
    if (this.settings.width && this.settings.height) {
      this.canvasWidth = this.settings.width
      this.canvasHeight = this.settings.height
    } else if (this.settings.width) {
      this.canvasWidth = this.settings.width
      this.canvasHeight = Math.ceil((this.image.height * this.canvasWidth) / this.image.width)
    } else if (this.settings.height) {
      this.canvasHeight = this.settings.height
      this.canvasWidth = Math.ceil((this.image.width * this.canvasHeight) / this.image.height)
    }
  }

  setContainSize() {
    // 横合わせ
    if (this.settings.width && this.canvasWidth > this.settings.width) {
      this.canvasHeight = Math.ceil((this.settings.width / this.canvasWidth) * this.canvasHeight)
      this.canvasWidth = this.settings.width
    }
    // 縦合わせ
    if (this.settings.height && this.canvasHeight > this.settings.height) {
      this.canvasWidth = Math.ceil((this.settings.height / this.canvasHeight) * this.canvasWidth)
      this.canvasHeight = this.settings.height
    }
  }

  async resize() {
    this._transformCoordinate()
    this.canvasContext.fillStyle = this.settings.bgColor
    this.canvasContext.fillRect(0, 0, this.canvasWidth, this.canvasHeight)
    this.canvasContext.drawImage(this.image, 0, 0, this.canvasWidth, this.canvasHeight)
    await pica.resize(this.canvas, this.canvas)
  }

  _transformCoordinate() {
    const ROTATE_RATIO = 0.5
    let canvas = this.canvas
    let w = this.canvasWidth
    let h = this.canvasHeight
    if (this.orientation > 4) {
      canvas.width = h
      canvas.height = w
    } else {
      canvas.width = w
      canvas.height = h
    }
    let ctx = canvas.getContext('2d')

    // NOTE: 数値はexifのorientation
    // 1: そのまま
    // 2: 上下反転(上下鏡像?)
    // 3: 180度回転
    // 4: 左右反転
    // 5: 上下反転、時計周りに270度回転
    // 6: 時計周りに90度回転
    // 7: 上下反転、時計周りに90度回転
    // 8: 時計周りに270度回転
    switch (this.orientation) {
      case 2:
        ctx.translate(w, 0), ctx.scale(-1, 1)
        break
      case 3:
        ctx.translate(w, h), ctx.rotate(Math.PI)
        break
      case 4:
        ctx.translate(0, h), ctx.scale(1, -1)
        break
      case 5:
        ctx.rotate(ROTATE_RATIO * Math.PI), ctx.scale(1, -1)
        break
      case 6:
        ctx.rotate(ROTATE_RATIO * Math.PI), ctx.translate(0, -h)
        break
      case 7:
        ctx.rotate(ROTATE_RATIO * Math.PI), ctx.translate(w, -h), ctx.scale(-1, 1)
        break
      case 8:
        ctx.rotate(-ROTATE_RATIO * Math.PI), ctx.translate(-w, 0)
    }
  }
}
